// Page: account-details-popup  (dashboard "account details" overlay)
//
// Ported from the inline <script> in
//   Enrollment_modules/dashboard/account-details-popup.module/module.html
//
// The popup is shown by the sibling dashboard/enrolled-accounts module (it sets
// `.accountDetailsView-main` display to block); this module only owns the close
// button. `root` IS the `.accountDetailsView-main` element, so close = hide root.
//
// FAITHFUL PORT: the original wired the close handler at parse time; here it runs
// on domReady via init. self-serve/main.module carries its own separate copy of
// this popup logic (Wave 6) — unaffected.

export function init(root: HTMLElement): void {
__ea_trace("modules/account/account-details-popup.ts","init",[root],["root"]);
  const closeBtn = root.querySelector<HTMLElement>(".accCrosssBtn img")
  closeBtn?.addEventListener("click", () => {
__ea_trace("modules/account/account-details-popup.ts","(anon)",[],[]);
    root.style.display = "none"
  })
}
